import {createListFromObject} from "../../../../Utilities/Types/listUtilities";

export const OWN_LOAN_STATUS = {
    "InReview" : 1,
    "BackOrder" : 2,
    "OrderSubmitted" : 3,
    "OutOfStock" : 4,
    "Discontinued" : 5,
    "Cancelled" : 6
};

export const OWN_LOAN_STATUS_LIST = createListFromObject(OWN_LOAN_STATUS);

export const OWN_LOAN_HISTORY_STATUS_LIST = OWN_LOAN_STATUS_LIST.slice(1);
